import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
    { label: 'Features', path: '/landing-page' },
    { label: 'Pricing', path: '/landing-page' },
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Accounts', path: '/accounts-overview' }],

    company: [
    { label: 'About Us', path: '/about-us' },
    { label: 'Blog', path: '/public-blog' },
    { label: 'Careers', path: '/landing-page' },
    { label: 'Contact', path: '/landing-page' }],

    resources: [
    { label: 'Help Center', path: '/landing-page' },
    { label: 'Privacy Policy', path: '/terms' },
    { label: 'Terms of Service', path: '/terms' },
    { label: 'Security', path: '/landing-page' }]

  };

  const socialLinks = [
  { icon: 'Twitter', label: 'Twitter', url: '#' },
  { icon: 'Facebook', label: 'Facebook', url: '#' },
  { icon: 'Linkedin', label: 'LinkedIn', url: '#' },
  { icon: 'Instagram', label: 'Instagram', url: '#' }];


  return (
    <footer className="bg-secondary text-secondary-foreground py-12 md:py-16 lg:py-20">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10 lg:gap-12 mb-12 md:mb-16">
          <div className="lg:col-span-2">
            <div
              className="flex items-center cursor-pointer mb-6 transition-smooth hover:opacity-80"
              onClick={() => navigate('/landing-page')}>

              <div className="flex items-center justify-center w-12 h-12 bg-primary/20 rounded-lg">
                
              </div>
              <span className="ml-3 text-xl font-heading font-semibold">
                Rovyn Budget
              </span>
            </div>
            <p className="text-sm md:text-base text-secondary-foreground/80 mb-6 max-w-md leading-relaxed">
              Your comprehensive financial companion for tracking expenses, managing accounts, and gaining powerful insights into your financial future.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks?.map((social, index) =>
              <a
                key={index}
                href={social?.url}
                aria-label={social?.label}
                className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-lg hover:bg-primary/20 transition-smooth">

                  <Icon name={social?.icon} size={20} color="currentColor" />
                </a>
              )}
            </div>
          </div>

          

















          <div>
            <h3 className="text-base md:text-lg font-heading font-semibold mb-4 md:mb-6">
              Company
            </h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) =>
              <li key={index}>
                  <button
                  onClick={() => navigate(link?.path)}
                  className="text-sm md:text-base text-secondary-foreground/80 hover:text-primary transition-smooth min-h-[44px] inline-flex items-center">

                    {link?.label}
                  </button>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-heading font-semibold mb-4 md:mb-6">
              Resources
            </h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link, index) =>
              <li key={index}>
                  <button
                  onClick={() => navigate(link?.path)}
                  className="text-sm md:text-base text-secondary-foreground/80 hover:text-primary transition-smooth min-h-[44px] inline-flex items-center">

                    {link?.label}
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-foreground/80 font-caption text-center md:text-left">
              &copy; {currentYear} Rovyn Budget. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <button
                onClick={() => navigate('/terms')}
                className="text-sm text-secondary-foreground/80 hover:text-primary transition-smooth min-h-[44px] inline-flex items-center">

                Privacy Policy
              </button>
              <button
                onClick={() => navigate('/terms')}
                className="text-sm text-secondary-foreground/80 hover:text-primary transition-smooth min-h-[44px] inline-flex items-center">

                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;